
    <a [attr.href]="href"
       [attr.title]="label"
       [textContent]="user.name">
    </a>
  